<template>
    <div class="ion-page">
        <ion-header>
            <ion-toolbar>
                <ion-buttons v-slot: start>
                <ion-back-button default-href="#" @click="navigatePreviousPage"></ion-back-button>
                <ion-title>Customer Profile / <span class="ion-sub-title">{{profileId}}</span> </ion-title>
                </ion-buttons>
                
            </ion-toolbar>
        </ion-header>
        <ion-content class="ion-padding">
            <ProfileView />
        </ion-content>
    </div>
</template>

<script>
import { defineComponent } from "vue";
import { IonHeader, IonToolbar, IonButtons, IonBackButton, IonContent } from "@ionic/vue";

import ProfileView from "@/components/account/ProfileView.vue";
export default defineComponent ({
    name: 'customerProfile',
    components: {
        ProfileView, IonHeader, IonToolbar, IonButtons, IonBackButton, IonContent
    },
    data() {
        return {
            viewmode: false,
            profileId: "New"
        }
    },
    async mounted() {
        if (this.$route.params.profileId) {
        if (this.$route.query.mode) {
            this.viewmode = false;
            this.profileId = "Edit";
        } else {
            this.viewmode = true;
            this.profileId = "Detail";
        }
        }
    },
    methods: {
        navigatePreviousPage() {
            this.$router.go(-1)
        }
    }
})
</script>